import { useParams } from "react-router-dom";

import {
  RenderConnectivity,
  RenderDeviceReboot,
  getReadableTime,
  isDateMoreThanThirtyMinutesOld,
} from "../../utils/utils";
import { ReactComponent as FourGang } from "../../img/Devices/4Gang.svg";
import {
  BrilliantDeviceTypes,
  EBrilliantControlType,
  IBrilliantControlsCard,
} from "../../interfaces/interfaces";
import { ReactComponent as OneGang } from "../../img/Devices/1Gang.svg";
import { ReactComponent as ThreeGang } from "../../img/Devices/3Gang.svg";
import { ReactComponent as TwoGang } from "../../img/Devices/2Gang.svg";
import { ReactComponent as UnknownControl } from "../../img/Devices/UnknownControl.svg";

import BrilliantDeviceCard from "./BrilliantDeviceCard";

export const gangImage = (
  gangNumber: number,
  isReconfiguring: boolean,
  controlType: EBrilliantControlType
) => {
  const iconStyle = isReconfiguring
    ? "brilliant-card-img-left brilliant-card-img-left-fill disabled"
    : "brilliant-card-img-left brilliant-card-img-left-fill";
  if (controlType === EBrilliantControlType.PLUG_IN) {
    return <TwoGang title="Plug-in Control" className={iconStyle} />;
  }
  if (gangNumber === 1) {
    return <OneGang title="1-Switch Control" className={iconStyle} />;
  }
  if (gangNumber === 2) {
    return <TwoGang title="2-Switch Control" className={iconStyle} />;
  }
  if (gangNumber === 3) {
    return <ThreeGang title="3-Switch Control" className={iconStyle} />;
  }
  if (gangNumber === 4) {
    return <FourGang title="4-Switch Control" className={iconStyle} />;
  }
  return <UnknownControl title="Unknown control" className={iconStyle} />;
};

export interface IBrilliantControlCardComponentPros {
  data: IBrilliantControlsCard;
  isProView?: boolean;
}

const BrilliantControlCard: React.FC<IBrilliantControlCardComponentPros> = ({
  data,
  isProView,
}) => {
  const params = useParams();
  const { propertyId } = params;
  const isControlOffline = isDateMoreThanThirtyMinutesOld(
    data.lastKnownCloudSync
  );
  return (
    <div>
      <BrilliantDeviceCard
        id={data.id}
        name={data.name}
        description={
          data.controlType === EBrilliantControlType.PLUG_IN
            ? "Plug-In"
            : `${data.numGangs} Switch Control`
        }
        isReconfiguring={data.isReconfiguring}
        icon={gangImage(data.numGangs, data.isReconfiguring, data.controlType)}
        isOffline={isControlOffline}
        lastOnline={
          isControlOffline
            ? getReadableTime(data.lastKnownCloudSync)
            : undefined
        }
        isProView={isProView}
        shouldShowSettingsRender={isProView}
        deviceType={BrilliantDeviceTypes.CONTROL}
      />
      {isProView && (
        <div className="brilliant-card-container-reboot">
          <div className="brilliant-card-container-reboot-inner">
            <RenderConnectivity
              connectionStrength={data.connectionStrength || 0}
              deviceDetails={false}
              isOfflineDevice={isControlOffline}
            />
            <RenderDeviceReboot
              deviceId={data.id}
              propertyId={propertyId || ""}
              isDeviceOffline={isControlOffline}
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default BrilliantControlCard;
